import SavingsPolicyOptions from "../savings/datasets/savings_policy_options";

export const reformatTotalSavingsArr = (totalSavingsArr) => {
    let savingSummaryArr = [];
    let sortNbr = 0;
    let grandTotalSavings = 0;
    let grandTotalDeposits = 0;
    let savingsClass = "";
    let rateOfReturn = 0;
    for (let i=0; i<totalSavingsArr.length; i++){
        const totalSavingsObj = totalSavingsArr[i];
        const savingsTypeObj = SavingsPolicyOptions.find(elem => elem.type === totalSavingsObj.savingsType);
        const savingsAccountName = savingsTypeObj.shortName;
        const totalDeposit = +totalSavingsObj.totalDeposit + +totalSavingsObj.totalTransferAmt.toFixed(2);
        const totalCurrentValue = +totalSavingsObj.totalSavings;
        const totalGainLoss = (+totalCurrentValue - +totalDeposit).toFixed(2);
        if (totalDeposit !== 0){
            rateOfReturn = ((+totalGainLoss / +totalDeposit) * 100).toFixed(2);
        }
        sortNbr += 1;
        savingsClass = totalSavingsObj.savingsClass;
        const savingAccountObj = {
            accountLabel: "",  
            accountType: totalSavingsObj.savingsClass, 
            subType: savingsAccountName, 
            totalInitialValue: +totalDeposit, 
            totalCurrentValue: +totalCurrentValue, 
            totalGainLoss: totalGainLoss, 
            rateOfReturn: rateOfReturn,
            sortNbr: sortNbr}
        savingSummaryArr.push(savingAccountObj)
        grandTotalDeposits += +totalDeposit;
        grandTotalSavings += +totalSavingsObj.totalSavings;
    }
    const totalGainLoss = (+grandTotalSavings).toFixed(2) - (+grandTotalDeposits).toFixed(2);
    rateOfReturn = 0;
    if (grandTotalDeposits !== 0){
        rateOfReturn = ((+totalGainLoss / +grandTotalDeposits) * 100).toFixed(2);
    }
    sortNbr += 1;
    const savingAccountObj = {
        accountLabel: "",  
        accountType: savingsClass, 
        subType: "Total", 
        totalInitialValue: +grandTotalDeposits, 
        totalCurrentValue: +grandTotalSavings, 
        totalGainLoss: totalGainLoss, 
        rateOfReturn: rateOfReturn,
        sortNbr: sortNbr}
    savingSummaryArr.push(savingAccountObj)
    return savingSummaryArr;
}
export default reformatTotalSavingsArr;